// extracted by mini-css-extract-plugin
export default {"crumbs_link":"CustomBreadcrumbs_crumbs_link__9si8I"};